import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

import vuegtm from 'vue-gtm'

Vue.use(vuegtm, {
  id: 'GTM-NNVS7XD', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  //vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
});

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home/Home"),
    }, {
      path: "/search",
      name: "search",
      component: () => import("@/views/Search/Search"),
      props: true,
      meta: { breadcrumb: [
            { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
            { text: 'Suche', active: true},
        ]},
    }, {
      name: "books",
      path: "/books",
      component: () => import("@/views/Books/Books"),
    }, {
      name: "book",
      path: "/books/view/:slug",
      component: () => import("@/views/Books/Book"),
      props: true,
      meta: { breadcrumb: [
            { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
            { text: 'Bücher', to: { name: 'home'}},
            { text: 'Buchansicht', active: true}
        ]},
    }, {
      name: "book-edit",
      path: "/books/edit/:slug?",
      props: true,
      component: () => import("@/views/Books/BookEdit"),
      meta: {
        requiresAuth: true,
        breadcrumb: [
            { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
            { text: 'Bücher', to: { name: 'home'}},
            { text: 'Buchansicht', to: { name: 'book'}},
            { text: 'Bearbeiten', active: true}
        ]},
    }, {
      name: "book-new",
      path: "/books/add",
      props: true,
      component: () => import("@/views/Books/BookEdit"),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Bücher', to: { name: 'home'}},
          { text: 'Buch hinzufügen', active: true}
        ]},
    }, {
      name: "articles",
      path: "/articles",
      component: () => import("@/views/Articles/Articles"),
      props: true,
      meta: { breadcrumb: [
            { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
            { text: 'Artikel', active: true}
        ]},
    }, {
      name: "article",
      path: "/articles/view/:slug",
      component: () => import("@/views/Articles/Article"),
      props: true,
      meta: { breadcrumb: [
            { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
            { text: 'Artikel', to: { name: 'articles'}},
            { text: 'Artikelansicht', active: true}
        ]},
    }, {
      name: "article-old",
      path: "/etzold-archiv/:slug",
      redirect: { name: 'article' }
    }, {
      name: "article-old",
      path: "/etzold-archiv/:slug/:rest",
      redirect: { name: 'article' }
    }, {
      name: "article-edit",
      path: "/articles/edit/:slug?",
      props: true,
      component: () => import("@/views/Articles/ArticleEdit"),
      meta: {
        requiresAuth: true,
        breadcrumb: [
            { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
            { text: 'Artikel', to: { name: 'articles'}},
            { text: 'Artikelansicht', to: { name: 'article'}},
            { text: 'Bearbeiten', active: true}
        ]},
    }, {
      name: "article-new",
      path: "/articles/add",
      props: true,
      component: () => import("@/views/Articles/ArticleEdit"),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Artikel', to: { name: 'articles'}},
          { text: 'Artikel hinzufügen', active: true}
        ]},
    }, {
      name: "videos",
      path: "/videos",
      component: () => import("@/views/Articles/Videos"),
      props: true,
      meta: { breadcrumb: [
            { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
            { text: 'Videos', active: true}
        ]},
    }, {
      name: "blog",
      path: "/blog",
      component: () => import("@/views/Articles/Blog"),
      props: true,
      meta: { breadcrumb: [
            { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
            { text: 'Blog', active: true}
        ]},
    }, {
      name: "product-edit",
      path: "/products/edit/:slug",
      props: true,
      component: () => import("@/views/Products/ProductEdit"),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Dashboard', to: { name: 'dashboard'}},
          { text: 'DK-Produkte verwalten', to: { name: 'dk-product-manager'}},
          { text: 'Produkt bearbeiten', active: true}
        ]},
    }, {
      name: "product-new",
      path: "/products/add",
      props: true,
      component: () => import("@/views/Products/ProductEdit"),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Dashboard', to: { name: 'dashboard'}},
          { text: 'DK-Produkte verwalten', to: { name: 'dk-product-manager'}},
          { text: 'Produkt hinzufügen', active: true}
        ]},
    }, {
      name: "vorauswahl-old",
      path: "/vorauswahl/:slug",
      redirect: { name: 'book' }
    }, {
      name: "band-old",
      path: "/band:slug",
      redirect: { name: 'book' }
    }, {
      name: "band-old",
      path: "/band:slug/:rest",
      redirect: { name: 'book' }
    }, {
      name: "dashboard",
      path: "/dashboard",
      component: () => import("@/views/Admin/Dashboard"),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Dashboard', active: true}
        ]},
        children: [
          {
            name: "variant-manager",
            path: "variant-manager",
            component: () => import("@/views/Admin/VariantManager"),
            meta: { breadcrumb: [
                { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
                { text: 'Dashboard', to: { name: 'dashboard'}},
                { text: 'Automodelle verwalten', active: true}
              ]},
          },
          {
            name: "dk-product-manager",
            path: "dk-product-manager",
            component: () => import("@/views/Products/DkProductManager"),
            meta: { breadcrumb: [
                { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
                { text: 'Dashboard', to: { name: 'dashboard'}},
                { text: 'DK-Produkte verwalten', active: true}
              ]},
          },
        ]
    }, {
      path: "/login:redirect?",
      name: "login",
      component: () => import("@/views/Admin/Login"),
      meta: { breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Dashboard', to: { name: 'dashboard'}},
          { text: 'Login', active: true}
        ]},
    }, {
      name: "legal-notice",
      path: "/impressum",
      component: () => import("@/views/Home/LegalNotice"),
      meta: { breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Impressum', active: true}
        ]},
    }, {
      name: "author",
      path: "/author/:slug",
      component: () => import("@/views/Author/Author"),
      meta: { breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Autor', active: true}
        ]},
    }, {
      name: "author-edit",
      path: "/author/edit/:slug",
      component: () => import("@/views/Author/AuthorEdit"),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { html: '<i class="material-icons">home</i>', to: { name: 'home'}},
          { text: 'Autor', to: { name: 'author'}},
          { text: 'Bearbeiten', active: true}
        ]},
    },
  ]
});

export default router;
